import { toast } from 'sonner';

/**
 * Structured error handler for API and UI errors.
 * Logs to console and shows a user-friendly toast notification.
 */
export function handleError(context, error, options = {}) {
  const { silent = false, fallbackMessage } = options;
  const rawDetail = error?.response?.data?.detail;
  const detail = (rawDetail && typeof rawDetail === 'object' && !Array.isArray(rawDetail))
    ? (rawDetail.message || rawDetail.msg || JSON.stringify(rawDetail))
    : rawDetail;
  const message = detail
    || error?.response?.data?.message
    || error?.message
    || fallbackMessage
    || 'Something went wrong';

  console.error(`[${context}]`, message, error);

  if (!silent) {
    toast.error(message);
  }
}
